// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PayrollRefundDecisionNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface PayrollRefundDecisionNestedInput {
refund_id: number
action: string
categoria_id?: number
reason?: string
}

registerContract('PayrollRefundDecisionNestedInput', {
  refund_id:    { type: 'number',  required: true },
  action:       { type: 'string',  required: true },
  categoria_id: { type: 'number',  required: false },
  reason:       { type: 'string',  required: false },
})
